import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-profile-note',
  templateUrl: './edit-note.component.html',
  styleUrls: ['./edit-note.component.css']
})
export class EditProfileNoteComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
